const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoorWhite1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 567.81 1079.23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path762",
    d: "M512.82,55.93,568.05.7V1079.93H512.82V55.93",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#edeef0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path764",
    d: "M.25.7,55.48,55.93v1024H.25V.7",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#edeef0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path766",
    d: "M50.26,50.7l5.22,5.23v1024H50.26V50.7",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#c5c6c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path768",
    d: "M.25.7,5.47,5.91v1074H.25V.7",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#f7f6f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path770",
    d: "M568.05.7l-5.22,5.21v1074h5.22V.7",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#c5c6c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path772",
    d: "M518,50.7l-5.22,5.23v1024H518V50.7",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#f7f6f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path774",
    d: "M55.48,55.93.25.7h567.8L512.82,55.93H55.48",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#edeef0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path776",
    d: "M50.26,50.7H518l-5.22,5.23H55.48L50.26,50.7",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#a8a9aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path778",
    d: "M.25.7h567.8l-5.22,5.21H5.47L.25.7",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#faf9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path780",
    d: "M512.82,1079.93H55.48V55.93H512.82v1024",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#89898a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path782",
    d: "M60.82,1079.93V61.26H507.48V1079.93H60.82",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#edeef0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path784",
    d: "M413.76,975.29H154.54V165.91H413.76V975.29",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#c5c6c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path786",
    d: "M413.76,975.29H284.15V165.91H413.76V975.29",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#f7f6f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path788",
    d: "M167.88,962V179.25H400.42V962H167.88",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#e0e2e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path790",
    d: "M154.54,165.91l13.34,13.34H400.42l13.34-13.34H154.54",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#a8a9aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path792",
    d: "M413.76,975.29,400.42,962H167.88l-13.34,13.34H413.76",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#faf9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path794",
    d: "M108.43,584.69H74.93V551.18h33.5v33.51",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path796",
    d: "M108.43,584.69H91.68V551.18h16.75v33.51",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path798",
    d: "M104,580.25H79.36V555.62H104v24.63",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path800",
    d: "M74.93,551.18l4.43,4.44H104l4.43-4.44H74.93",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path802",
    d: "M74.93,584.69l4.43-4.44H104l4.43,4.44H74.93",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path804",
    d: "M180.41,576.69H82.91V559.18h97.5v17.51",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path806",
    d: "M180.41,576.69H98.33V559.18h82.08v17.51",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path808",
    d: "M177.31,573.58H86V562.29h91.3v11.29",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path810",
    d: "M82.91,559.18l3.1,3.11h91.3l3.1-3.11H82.91",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path812",
    d: "M82.91,576.69l3.1-3.11h91.3l3.1,3.11H82.91",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path814",
    d: "M400.42,337.25H167.88v-2.92H400.42v2.92",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path816",
    d: "M400.42,334.33H167.88v-1.47H400.42v1.47",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path818",
    d: "M400.42,338.71H167.88v-1.46H400.42v1.46",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path820",
    d: "M400.42,493.79H167.88v-2.93H400.42v2.93",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path822",
    d: "M400.42,490.86H167.88v-1.45H400.42v1.45",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path824",
    d: "M400.42,495.25H167.88v-1.46H400.42v1.46",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path826",
    d: "M400.42,650.33H167.88v-2.92H400.42v2.92",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path828",
    d: "M400.42,647.41H167.88v-1.47H400.42v1.47",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path830",
    d: "M400.42,651.79H167.88v-1.46H400.42v1.46",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path832",
    d: "M400.42,806.87H167.88V804H400.42v2.92",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path834",
    d: "M400.42,804H167.88v-1.46H400.42V804",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path836",
    d: "M400.42,808.34H167.88v-1.47H400.42v1.47",
    transform: "translate(-0.25 -0.7)",
    style: {
      fill: "#757575"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoorWhite1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/door-white1.8b2bc1a7b6e2aed096ab522f1824d314.svg";